/**
 * jQuery Tabs Plugin
 * Version: 1.0.0
 * Author: Len Bradley (lenbradley@ninesphere.com)
 *
 * Settings:
 *
 *     labelParent: The label parent element
 *     labelChild: The label parent element child elements to target
 *     tabSelector: The actual tab selector to target
 *     activeClass: The class to apply to the active tab
 *
 * Example:
 *          $('.tabs').tabs({
 *              tabSelector: '.tab'
 *          });
 */

( function($) {
    "use strict";

    $.fn.tabs = function( settings ) {

        if ( typeof settings === 'undefined' ) {
            var settings = {};
        }

        var defaults = {
            labelParent : 'ul.labels',
            labelChild  : 'li.label > a',
            tabSelector : '.tab',
            activeClass : 'active',
            nextTab     : '',
            prevTab     : ''
        };

        settings = $.extend( {}, defaults, settings );

        return this.each( function() {

            var parent = this;

            if ( typeof this.tabs !== 'undefined' ) {
                return false;
            }

            this.tabs = {};

            this.tabs.getTabLabels = function() {
                return $(parent).find( settings.labelParent + ' ' + settings.labelChild );
            }

            this.tabs.getTab = function( index ) {

            }

            this.tabs.getTabs = function() {
                return $(parent).find( settings.tabSelector );
            }

            this.tabs.getCurrentTab = function( flag ) {

                var activeTab = 0;

                parent.tabs.getTabLabels().each( function( key, element ) {

                    if ( $(element).parent().hasClass( settings.activeClass ) ) {
                        activeTab = key;
                    }
                });

                return activeTab;
            }

            this.tabs.getPrevTab = function() {

                var prevTab = 0;
                var current = parent.tabs.getCurrentTab();

                if ( current === 0 ) {
                    prevTab = parent.tabs.getTabs().length - 1;
                } else {
                    prevTab = current - 1;
                }

                return prevTab;
            }

            this.tabs.getNextTab = function() {

                var nextTab = 0;
                var current = parent.tabs.getCurrentTab();

                if ( current !== ( parent.tabs.getTabs().length - 1 ) ) {
                    nextTab = current + 1;
                }

                return nextTab;
            }

            this.tabs.goToTab = function( index ) {

                if ( typeof index === 'undefined' ) {
                    return false;
                }

                var labels  = parent.tabs.getTabLabels();
                var tabs    = parent.tabs.getTabs();

                labels.each( function( key, element ) {

                    var labelParent = $(this).parent();

                    if ( key != index ) {
                        labelParent.removeClass( settings.activeClass );
                    } else {
                        labelParent.addClass( settings.activeClass );
                    }
                });

                tabs.hide().eq(index).show();
            }

            this.tabs.setup = function() {

                var labels  = parent.tabs.getTabLabels();
                var tabs    = parent.tabs.getTabs();
                var initTab = 0;

                labels.each( function( key, element ) {

                    $(this).on( 'click', function(e) {
                        e.preventDefault();

                        var index = $(this).data('index');

                        parent.tabs.goToTab( index );

                        // console.clear();
                        // console.log( 'getCurrentTab : ' + parent.tabs.getCurrentTab() );
                        // console.log( 'getPrevTab : ' + parent.tabs.getPrevTab() );
                        // console.log( 'getNextTab : ' + parent.tabs.getNextTab() );
                    });

                    if ( $(this).data('selected') ) {
                        initTab = key;
                    }
                });

                if ( window.location.hash ) {

                    tabs.each( function( key, element ) {

                        var checkHash = $(this).data('hash');

                        if ( checkHash && checkHash == window.location.hash ) {
                            initTab = key;
                        }
                    });
                }

                if ( settings.prevTab ) {
                    $(settings.prevTab).on( 'click', function(e) {
                        e.preventDefault();
                        parent.tabs.goToTab( parent.tabs.getPrevTab() );
                    });
                }

                if ( settings.nextTab ) {
                    $(settings.nextTab).on( 'click', function(e) {
                        e.preventDefault();
                        parent.tabs.goToTab( parent.tabs.getNextTab() );
                    });
                }

                parent.tabs.goToTab( initTab );
            }

            this.tabs.setup();
        });
    }
}( jQuery ));